import {Inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from 'rxjs';
import {AuthenticationBaseService} from "../authentication-base.service";

/**
 * @deprecated The class should not be used or developed. AuthInterceptorProvider injects token.
 * @see HttpClient
 */
@Injectable()
export class HttpService {
  constructor(@Inject(HttpClient)private http: HttpClient) {}

  /**
   * @deprecated The method should not be used.
   * @see HttpClient
   */
  get(url: string, params?: any, authService?: AuthenticationBaseService): Observable<any> {
    return new Observable((observer) => {
      if (authService) {
        authService.getAccessToken().then(token => {
          if (!params) {
            params = {};
          }
          const accessToken = typeof token === 'object' ? token.access_token : token;
          params.headers = { Authorization: `Bearer ${accessToken}` };
          const sub = this.http.get(url, params).subscribe(response => {
            observer.next(response);
            sub.unsubscribe();
          });
        })
      } else {
        const sub = this.http.get(url, params).subscribe(response => {
          observer.next(response);
          sub.unsubscribe();
        });
      }

    })

  }

  /**
   * @deprecated The method should not be used.
   * @see HttpClient
   */
  post(url: string, params?: any, authService?: AuthenticationBaseService): Observable<any> {
    return new Observable((observer) => {
      if (authService) {
        authService.getAccessToken().then(token => {
          if (!params) {
            params = {};
          }
          const accessToken = typeof token === 'object' ? token.access_token : token;
          const options = {headers: { Authorization: `Bearer ${accessToken}` }};
          const sub = this.http.post(url, params, options).subscribe(response => {
            observer.next(response);
            sub.unsubscribe();
          });
        })
      } else {
        const sub = this.http.post(url, params).subscribe(response => {
          observer.next(response);
          sub.unsubscribe();
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/services/http/http.service.ts